/**
 * Model Viewer Service
 *
 * @version
 * 4.71.0 OAUI-684 Improve shared code and add interfaces
 * 4.68.0 DEVOPS-928 Add environment route resolver to all Angular repos
 * 4.64.0 OAUI-646 Upgrades for Angular v16
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.56.0 OAUI-596 Migrate Large Model Viewer into Angular
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2023-2024 Build Centrix
 */
import { Inject, Injectable } from '@angular/core';
import { WdLocalEnvironmentService } from '../environment/wd-local-environment.service';
import { BehaviorSubject } from 'rxjs';
import { WdLocalSharedFunctionsService } from '../shared/wd-local-shared-functions.service';

@Injectable({
  providedIn: 'root',
})
export class WdModelViewerService {
  baseApiUrl: string;
  isLoading = new BehaviorSubject(false);

  constructor(
    public environment: WdLocalEnvironmentService,
    public wdLocalSharedFunctions: WdLocalSharedFunctionsService,
    @Inject('wdErrorService') public wdErrorService: any,
    @Inject('wdOauth2HttpService') public wdOauth2HttpService: any,
  ) {
    this.baseApiUrl = this.wdLocalSharedFunctions.orderingApiUrl;
  }

  /**
   * Get Forge Viewer data for the order from the API
   *
   * @since 4.56.0
   *
   */
  async fetchViewerOrderData(orderIndex: string): Promise<any> {
    this.isLoading.next(true);

    try {
      return await this.wdOauth2HttpService.get(
        `${this.baseApiUrl}autodesk/lmv?orderId=${orderIndex}`,
      );
    } catch (error) {
      this.wdErrorService.userError(
        'Error',
        'Failed to load Forge Viewer order data',
      );
    } finally {
      this.isLoading.next(false);
    }
  }
}
